import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import { ReduxDispatch } from "../../models/ReduxProps";
import IStore from "../../models/IStore";
import ComuneModel from "./models/ComuneModel";
import LookUpEffect from "./LookUpEffect";
import TipoDocumentoModel from "./models/TipoDocumentoModel";
import CittadinanzaModel from "./models/CittadinanzaModel";
import NazioneModel from "./models/NazioneModel";
import TipoIndirizzoModel from "./models/TipoIndirizzoModel";
import AmministrazioneModel from "./models/AmministrazioneModel";
import TipoRichiedenteModel from "stores/tipo-richiedente/models/TipoRichiedenteModel";
import ConsensoPrivacyModel from "stores/consenso-privacy/models/ConsensoPrivacyModel";
import FondoModel from "./models/FondoModel";
import CqsOnlineTipoCodiceFiscaleModel from "stores/cqsonline/models/CqsOnlineTipoCodiceFiscaleModel";
import ModalitaErogazioneModel from "./models/ModalitaErogazioneModel";
import TipologiaPensioneModel from "./models/TipologiaPensioneModel";
import CategoriaAmministrativaModel from "./models/CategoriaAmministrativaModel";
import TipologiaImpegnoModel from "./models/TipologiaImpegnoModel";
import QuoteSocietaModel from "./models/QuoteSocietaModel";
import ImportoConIntermediariModel from "./models/ImportoConIntermediariModel";
import IstitutoFinanziarioModel from "./models/IstitutoFinanziarioModel";

type ActionUnion =
    | undefined
    | ConsensoPrivacyModel[]
    | TipoRichiedenteModel[]
    | ComuneModel[]
    | TipoDocumentoModel[]
    | CittadinanzaModel[]
    | NazioneModel[]
    | TipoIndirizzoModel[]
    | AmministrazioneModel[]
    | QuoteSocietaModel[]
    | IstitutoFinanziarioModel[]
    | HttpErrorResponseModel;

export default class LookUpAction {
    public static readonly REQUEST_CONSENSO_PRIVACY: string = "LookUpAction.REQUEST_CONSENSO_PRIVACY";
    public static readonly REQUEST_CONSENSO_PRIVACY_FINISHED: string = "LookUpAction.REQUEST_CONSENSO_PRIVACY_FINISHED";

    public static readonly REQUEST_TIPO_RICHIEDENTES: string = "LookUpAction.REQUEST_TIPO_RICHIEDENTES";
    public static readonly REQUEST_TIPO_RICHIEDENTES_FINISHED: string =
        "LookUpAction.REQUEST_TIPO_RICHIEDENTES_FINISHED";

    public static readonly REQUEST_COMUNE_NASCITA: string = "LookUpAction.REQUEST_COMUNE_NASCITA";
    public static readonly REQUEST_COMUNE_NASCITA_FINISHED: string = "LookUpAction.REQUEST_COMUNE_NASCITA_FINISHED";

    public static readonly REQUEST_COMUNE_RESIDENZA: string = "LookUpAction.REQUEST_COMUNE_RESIDENZA";
    public static readonly REQUEST_COMUNE_RESIDENZA_FINISHED: string = "LookUpAction.REQUEST_COMUNE_RESIDENZA_FINISHED";

    public static readonly REQUEST_TIPO_DOCUMENTO: string = "LookUpAction.REQUEST_TIPO_DOCUMENTO";
    public static readonly REQUEST_TIPO_DOCUMENTO_FINISHED: string = "LookUpAction.REQUEST_TIPO_DOCUMENTO_FINISHED";

    public static readonly REQUEST_CITTADINANZA: string = "LookUpAction.REQUEST_CITTADINANZA";
    public static readonly REQUEST_CITTADINANZA_FINISHED: string = "LookUpAction.REQUEST_CITTADINANZA_FINISHED";

    public static readonly REQUEST_NAZIONE: string = "LookUpAction.REQUEST_NAZIONE";
    public static readonly REQUEST_NAZIONE_FINISHED: string = "LookUpAction.REQUEST_NAZIONE_FINISHED";

    public static readonly REQUEST_TIPO_INDIRIZZO: string = "LookUpAction.REQUEST_TIPO_INDIRIZZO";
    public static readonly REQUEST_TIPO_INDIRIZZO_FINISHED: string = "LookUpAction.REQUEST_TIPO_INDIRIZZO_FINISHED";

    public static readonly REQUEST_AMMINISTRAZIONE: string = "LookUpAction.REQUEST_AMMINISTRAZIONE";
    public static readonly REQUEST_AMMINISTRAZIONE_FINISHED: string = "LookUpAction.REQUEST_AMMINISTRAZIONE_FINISHED";

    //campo non necessario
    // public static readonly REQUEST_QUALIFICA: string = "LookUpAction.REQUEST_QUALIFICA";
    // public static readonly REQUEST_QUALIFICA_FINISHED: string = "LookUpAction.REQUEST_QUALIFICA_FINISHED";

    public static readonly REQUEST_FONDO: string = "LookUpAction.REQUEST_FONDO";
    public static readonly REQUEST_FONDO_FINISHED: string = "LookUpAction.REQUEST_FONDO_FINISHED";

    // #region CQSonline
    public static readonly REQUEST_TIPO_DOCUMENTO_CQSOL: string = "LookUpAction.REQUEST_TIPO_DOCUMENTO_CQSOL";
    public static readonly REQUEST_TIPO_DOCUMENTO_CQSOL_FINISHED: string =
        "LookUpAction.REQUEST_TIPO_DOCUMENTO_CQSOL_FINISHED";

    public static readonly REQUEST_TIPO_CODICE_FISCALE_CQSOL: string = "LookUpAction.REQUEST_TIPO_CODICE_FISCALE_CQSOL";
    public static readonly REQUEST_TIPO_CODICE_FISCALE_CQSOL_FINISHED: string =
        "LookUpAction.REQUEST_TIPO_CODICE_FISCALE_CQSOL_FINISHED";

    public static readonly REQUEST_MODALITA_EROGAZIONE_CQSOL: string = "LookUpAction.REQUEST_MODALITA_EROGAZIONE_CQSOL";
    public static readonly REQUEST_MODALITA_EROGAZIONE_CQSOL_FINISHED: string =
        "LookUpAction.REQUEST_MODALITA_EROGAZIONE_CQSOL_FINISHED";

    public static readonly REQUEST_TIPOLOGIA_PENSIONE_CQSOL: string = "LookUpAction.REQUEST_TIPOLOGIA_PENSIONE_CQSOL";
    public static readonly REQUEST_TIPOLOGIA_PENSIONE_CQSOL_FINISHED: string =
        "LookUpAction.REQUEST_TIPOLOGIA_PENSIONE_CQSOL_FINISHED";

    public static readonly REQUEST_CATEGORIA_AMMINISTRATIVA_CQSOL: string =
        "LookUpAction.REQUEST_CATEGORIA_AMMINISTRATIVA_CQSOL";
    public static readonly REQUEST_CATEGORIA_AMMINISTRATIVA_CQSOL_FINISHED: string =
        "LookUpAction.REQUEST_CATEGORIA_AMMINISTRATIVA_CQSOL_FINISHED";

    public static readonly REQUEST_TIPOLOGIA_IMPEGNO_CQSOL: string = "LookUpAction.REQUEST_TIPOLOGIA_IMPEGNO_CQSOL";
    public static readonly REQUEST_TIPOLOGIA_IMPEGNO_CQSOL_FINISHED: string =
        "LookUpAction.REQUEST_TIPOLOGIA_IMPEGNO_CQSOL_FINISHED";

    public static readonly REQUEST_VOCI_AMMINISTRAZIONE_CONVENZIONE: string =
        "LookUpAction.REQUEST_VOCI_AMMINISTRAZIONE_CONVENZIONE";
    public static readonly REQUEST_VOCI_AMMINISTRAZIONE_CONVENZIONE_FINISHED: string =
        "LookUpAction.REQUEST_VOCI_AMMINISTRAZIONE_CONVENZIONE_FINISHED";

    public static readonly REQUEST_QUOTE_SOCIETARIE: string = "LookUpAction.REQUEST_QUOTE_SOCIETARIE";
    public static readonly REQUEST_QUOTE_SOCIETARIE_FINISHED: string = "LookUpAction.REQUEST_QUOTE_SOCIETARIE_FINISHED";

    public static readonly REQUEST_IMPORTI_INTERMEDIARI: string = "LookUpAction.REQUEST_IMPORTI_INTERMEDIARI";
    public static readonly REQUEST_IMPORTI_INTERMEDIARI_FINISHED: string =
        "LookUpAction.REQUEST_IMPORTI_INTERMEDIARI_FINISHED";

    public static readonly REQUEST_ISTITUTO_FINANZIARIO: string = "LookUpAction.REQUEST_ISTITUTO_FINANZIARIO";
    public static readonly REQUEST_ISTITUTO_FINANZIARIO_FINISHED: string =
        "LookUpAction.REQUEST_ISTITUTO_FINANZIARIO_FINISHED";
    public static readonly REQUEST_GET_CONSENSI_USER: string = "UserAction.REQUEST_GET_CONSENSI_USER";
    public static readonly REQUEST_GET_CONSENSI_USER_FINISHED: string = "UserAction.REQUEST_GET_CONSENSI_USER_FINISHED";
    // #endregion CQSonline

    public static readonly REQUEST_ERROR: string = "LookUpAction.REQUEST_ERROR";
    public static readonly REQUEST_ERROR_FINISHED: string = "LookUpAction.REQUEST_ERROR_FINISHED";

    public static requestConsensoPrivacy(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ConsensoPrivacyModel[]>(
                dispatch,
                LookUpAction.REQUEST_CONSENSO_PRIVACY,
                LookUpEffect.requestConsensoPrivacy
            );
        };
    }

    public static requestTipoRichiedentes(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<TipoRichiedenteModel[]>(
                dispatch,
                LookUpAction.REQUEST_TIPO_RICHIEDENTES,
                LookUpEffect.requestTipoRichiedentes
            );
        };
    }

    public static requestComuneNascita(comune: string, codice: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ComuneModel[]>(
                dispatch,
                LookUpAction.REQUEST_COMUNE_NASCITA,
                LookUpEffect.requestComuneNascita,
                comune,
                codice
            );
        };
    }

    public static requestComuneResidenza(comune: string, codice: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ComuneModel[]>(
                dispatch,
                LookUpAction.REQUEST_COMUNE_RESIDENZA,
                LookUpEffect.requestComuneResidenza,
                comune,
                codice
            );
        };
    }

    public static requestTipoDocumento(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<TipoDocumentoModel[]>(
                dispatch,
                LookUpAction.REQUEST_TIPO_DOCUMENTO,
                LookUpEffect.requestTipoDocumento
            );
        };
    }

    public static requestCittadinanza(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CittadinanzaModel[]>(
                dispatch,
                LookUpAction.REQUEST_CITTADINANZA,
                LookUpEffect.requestCittadinanza
            );
        };
    }

    public static requestNazione(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<NazioneModel[]>(
                dispatch,
                LookUpAction.REQUEST_NAZIONE,
                LookUpEffect.requestNazione
            );
        };
    }

    public static requestTipoIndirizzo(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<TipoIndirizzoModel[]>(
                dispatch,
                LookUpAction.REQUEST_TIPO_INDIRIZZO,
                LookUpEffect.requestTipoIndirizzo
            );
        };
    }

    public static requestAmministrazione(codiceTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AmministrazioneModel[]>(
                dispatch,
                LookUpAction.REQUEST_AMMINISTRAZIONE,
                LookUpEffect.requestAmministrazione,
                codiceTipoRichiedente
            );
        };
    }

    public static requestFondo(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<FondoModel[]>(
                dispatch,
                LookUpAction.REQUEST_FONDO,
                LookUpEffect.requestFondo
            );
        };
    }

    // #region CQSonline

    public static requestTipoDocumentoCQSonline(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<TipoDocumentoModel[]>(
                dispatch,
                LookUpAction.REQUEST_TIPO_DOCUMENTO_CQSOL,
                LookUpEffect.requestTipoDocumentoCQSonline
            );
        };
    }

    public static requestTipoCodiceFiscaleCQSonline(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CqsOnlineTipoCodiceFiscaleModel[]>(
                dispatch,
                LookUpAction.REQUEST_TIPO_CODICE_FISCALE_CQSOL,
                LookUpEffect.requestTipoCodiceFiscaleCQSonline
            );
        };
    }

    public static requestModalitaErogazione(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ModalitaErogazioneModel[]>(
                dispatch,
                LookUpAction.REQUEST_MODALITA_EROGAZIONE_CQSOL,
                LookUpEffect.requestModalitaErogazione
            );
        };
    }

    public static requestTipologiaPensione(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<TipologiaPensioneModel[]>(
                dispatch,
                LookUpAction.REQUEST_TIPOLOGIA_PENSIONE_CQSOL,
                LookUpEffect.requestTipologiaPensione
            );
        };
    }

    public static requestCategoriaAmministrativa(codiceTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CategoriaAmministrativaModel[]>(
                dispatch,
                LookUpAction.REQUEST_CATEGORIA_AMMINISTRATIVA_CQSOL,
                LookUpEffect.requestCategoriaAmministrativa,
                codiceTipoRichiedente
            );
        };
    }

    public static requestTipologiaImpegno(codiceTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<TipologiaImpegnoModel[]>(
                dispatch,
                LookUpAction.REQUEST_TIPOLOGIA_IMPEGNO_CQSOL,
                LookUpEffect.requestTipologiaImpegno,
                codiceTipoRichiedente
            );
        };
    }

    public static requestVociAmministrazioneConvenzione(codiceTipoRichiedente: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AmministrazioneModel[]>(
                dispatch,
                LookUpAction.REQUEST_VOCI_AMMINISTRAZIONE_CONVENZIONE,
                LookUpEffect.requestVociAmministrazioneConvenzione,
                codiceTipoRichiedente
            );
        };
    }

    public static requestQuoteSocietarie(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<QuoteSocietaModel[]>(
                dispatch,
                LookUpAction.REQUEST_QUOTE_SOCIETARIE,
                LookUpEffect.requestQuoteSocietarie
            );
        };
    }

    public static requestImportiConIntermediari(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ImportoConIntermediariModel[]>(
                dispatch,
                LookUpAction.REQUEST_IMPORTI_INTERMEDIARI,
                LookUpEffect.requestImportiConIntermediari
            );
        };
    }

    public static requestIstitutoFinanziari(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<IstitutoFinanziarioModel[]>(
                dispatch,
                LookUpAction.REQUEST_ISTITUTO_FINANZIARIO,
                LookUpEffect.requestIstitutiFinanziari
            );
        };
    }

    public static requestConsesiPrivacyUtente(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ConsensoPrivacyModel[]>(
                dispatch,
                LookUpAction.REQUEST_GET_CONSENSI_USER,
                LookUpEffect.requestConsesiPrivacyUtente
            );
        };
    }
    // #endregion CQSonline

    //campo non necessario
    // public static requestQualifica(): any {
    //     return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
    //         await ActionUtility.createThunkEffect<QualificaModel[]>(
    //             dispatch,
    //             LookUpAction.REQUEST_QUALIFICA,
    //             LookUpEffect.requestQualifica
    //         );
    //     };
    // }

    public static requestError(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<any>(dispatch, LookUpAction.REQUEST_ERROR, LookUpEffect.requestError);
        };
    }
}
